import React, { useState } from "react";

export default function EditProfile() {
    const [fullname, setFullname] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("success");

    const showMessage = (text, type = "success") => {
        setMessage(text);
        setMessageType(type);
        setTimeout(() => setMessage(""), 4000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = [];
        if (!fullname.trim()) errors.push("Full Name is required.");
        // if (!username.trim()) errors.push("Username is required.");
        // if (password && password.length < 6) errors.push("Password must be at least 6 characters.");

        if (errors.length > 0) {
            showMessage(errors.join(" "), "danger");
            return;
        }

        setLoading(true);
        const token = sessionStorage.getItem("token");
        try {
            const res = await fetch(`${process.env.REACT_APP_BASE_URL}cc/r/profile/update`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    fullname,
                    // username,
                    // password,
                }),
            });

            const data = await res.json();

            if (!res.ok) {
                if (data.errors) {
                    const messages = Object.values(data.errors).flat().join(" ");
                    showMessage(messages, "danger");
                } else {
                    showMessage("Failed to update profile.", "danger");
                }
            } else {
                showMessage("Profile updated successfully.", "success");
            }
        } catch (err) {
            console.error(err);
            showMessage("An error occurred while updating profile.", "danger");
        }

        setLoading(false);
    };

    return (
        <div>
            <h2 className="text-center mb-2 mt-4">Edit Profile</h2>
            <form className="d-flex flex-column align-items-center mt-4" onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Full Name"
                    className="inputPrimary p-2 mb-3 border"
                    value={fullname}
                    maxLength={50}
                    minLength={3}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z0-9\s.-]*$/.test(value)) {
                            setFullname(value);
                        }
                    }}
                />
                {/* <input
                    type="username"
                    placeholder="Usersname"
                    className="inputPrimary p-2 mb-3 border"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                /> */}
                {/* <input
                    type="password"
                    placeholder="Password"
                    className="inputPrimary p-2 mb-4 border"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                /> */}
                <button className="px-4 py-2 btnPrimary mx-auto" type="submit" disabled={loading}>
                    {loading ? "Updating..." : "Update Profile"}
                </button>
            </form>

            {message && (
                <div className={`alert alert-${messageType} text-center mt-3`} role="alert">
                    {message}
                </div>
            )}
        </div>
    );
}
